export default __webpack_public_path__ + "static/media/plus-icon.802bb294.svg";